export class StringUtil {
    static padWithZero(number: number, pad: number): string {
        let r = number.toString();
        while (r.length < pad)
            r = `0${r}`;
        return r;
    }
}